import {
  ADD_REPORT,
  DELETE_REPORT,
  FAILED_GROUPORDER_PDF,
  FETCH_GROUPORDER_DOWNLOAD,
  FETCH_REPORT,
  GET_REPORT,
  IS_LOADING_REPORT,
  REMOVE_REPORT,
  UPDATE_REPORT,
} from "./Report.constant";
export const initialState = {
  report: [],
  userData: {},
  isLoading: false,
};
const reportInformation = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REPORT:
    case FETCH_GROUPORDER_DOWNLOAD:
      return {
        ...state,
        userData: action.payload,
      };
    case ADD_REPORT:
      return {
        ...state,
        report: action.payload,
      };
    case GET_REPORT:
      return {
        ...state,
        report: action.payload,
      };
    case REMOVE_REPORT:
    case FAILED_GROUPORDER_PDF:
      return {
        ...state,
        userData: action.payload,
      };
    case UPDATE_REPORT:
      return {
        ...state,
        report: state.report.map((item) => {
          if (item?.id == action.payload?.id) {
            return {
              ...item,
              joined: action.payload?.joined,
            };
          }
          return item;
        }),
      };
    case DELETE_REPORT:
      return {
        ...state,
        form: {
          ...state.form.createGroupOrder,
          [action.payload]: {},
        },
      };
    case IS_LOADING_REPORT:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
};

export default reportInformation;
